// WHO Growth Standards Data (Birth to 5 years - 0-60 months)
// Data sourced from WHO Child Growth Standards
// Reference: https://www.who.int/tools/child-growth-standards

// Weight-for-age (kg) - Boys, Birth to 5 years
export const WHO_WEIGHT_FOR_AGE_BOYS = {
  // Month: { p3, p15, p50, p85, p97 }
  0: { p3: 2.5, p15: 2.9, p50: 3.3, p85: 3.9, p97: 4.3 },
  1: { p3: 3.4, p15: 3.9, p50: 4.5, p85: 5.1, p97: 5.7 },
  2: { p3: 4.4, p15: 4.9, p50: 5.6, p85: 6.3, p97: 7.0 },
  3: { p3: 5.1, p15: 5.6, p50: 6.4, p85: 7.2, p97: 8.0 },
  4: { p3: 5.6, p15: 6.2, p50: 7.0, p85: 7.9, p97: 8.7 },
  5: { p3: 6.1, p15: 6.7, p50: 7.5, p85: 8.4, p97: 9.2 },
  6: { p3: 6.4, p15: 7.1, p50: 7.9, p85: 8.8, p97: 9.7 },
  7: { p3: 6.7, p15: 7.4, p50: 8.3, p85: 9.2, p97: 10.1 },
  8: { p3: 7.0, p15: 7.7, p50: 8.6, p85: 9.6, p97: 10.5 },
  9: { p3: 7.2, p15: 8.0, p50: 8.9, p85: 9.9, p97: 10.9 },
  10: { p3: 7.5, p15: 8.2, p50: 9.2, p85: 10.2, p97: 11.2 },
  11: { p3: 7.7, p15: 8.4, p50: 9.4, p85: 10.5, p97: 11.5 },
  12: { p3: 7.8, p15: 8.6, p50: 9.6, p85: 10.8, p97: 11.8 },
  15: { p3: 8.4, p15: 9.2, p50: 10.3, p85: 11.5, p97: 12.6 },
  18: { p3: 8.9, p15: 9.7, p50: 10.9, p85: 12.2, p97: 13.4 },
  21: { p3: 9.3, p15: 10.2, p50: 11.5, p85: 12.9, p97: 14.1 },
  24: { p3: 9.8, p15: 10.8, p50: 12.2, p85: 13.6, p97: 15.0 },
  30: { p3: 10.5, p15: 11.5, p50: 13.0, p85: 14.6, p97: 16.1 },
  36: { p3: 11.3, p15: 12.4, p50: 14.0, p85: 15.7, p97: 17.3 },
  42: { p3: 12.0, p15: 13.1, p50: 14.8, p85: 16.7, p97: 18.4 },
  48: { p3: 12.7, p15: 13.9, p50: 15.7, p85: 17.7, p97: 19.6 },
  54: { p3: 13.4, p15: 14.7, p50: 16.6, p85: 18.8, p97: 20.8 },
  60: { p3: 14.1, p15: 15.4, p50: 17.5, p85: 19.8, p97: 22.0 }
};

// Weight-for-age (kg) - Girls, Birth to 5 years  
export const WHO_WEIGHT_FOR_AGE_GIRLS = {
  0: { p3: 2.4, p15: 2.8, p50: 3.2, p85: 3.7, p97: 4.0 },
  1: { p3: 3.2, p15: 3.6, p50: 4.2, p85: 4.8, p97: 5.4 },
  2: { p3: 4.0, p15: 4.5, p50: 5.1, p85: 5.8, p97: 6.5 },
  3: { p3: 4.6, p15: 5.1, p50: 5.8, p85: 6.6, p97: 7.4 },
  4: { p3: 5.1, p15: 5.6, p50: 6.4, p85: 7.3, p97: 8.1 },
  5: { p3: 5.5, p15: 6.1, p50: 6.9, p85: 7.8, p97: 8.7 },
  6: { p3: 5.8, p15: 6.4, p50: 7.3, p85: 8.2, p97: 9.2 },
  7: { p3: 6.1, p15: 6.7, p50: 7.6, p85: 8.6, p97: 9.6 },
  8: { p3: 6.3, p15: 7.0, p50: 7.9, p85: 9.0, p97: 10.0 },
  9: { p3: 6.6, p15: 7.3, p50: 8.2, p85: 9.3, p97: 10.4 },
  10: { p3: 6.8, p15: 7.5, p50: 8.5, p85: 9.6, p97: 10.7 },
  11: { p3: 7.0, p15: 7.7, p50: 8.7, p85: 9.9, p97: 11.0 },
  12: { p3: 7.1, p15: 7.9, p50: 8.9, p85: 10.1, p97: 11.3 },
  15: { p3: 7.7, p15: 8.5, p50: 9.6, p85: 10.9, p97: 12.2 },
  18: { p3: 8.2, p15: 9.0, p50: 10.2, p85: 11.6, p97: 13.0 },
  21: { p3: 8.6, p15: 9.5, p50: 10.9, p85: 12.3, p97: 13.8 },
  24: { p3: 9.0, p15: 10.0, p50: 11.5, p85: 13.0, p97: 14.6 },
  30: { p3: 9.7, p15: 10.8, p50: 12.4, p85: 14.1, p97: 15.9 },
  36: { p3: 10.4, p15: 11.5, p50: 13.3, p85: 15.2, p97: 17.2 },
  42: { p3: 11.0, p15: 12.2, p50: 14.1, p85: 16.2, p97: 18.4 },
  48: { p3: 11.7, p15: 13.0, p50: 15.0, p85: 17.3, p97: 19.7 },
  54: { p3: 12.3, p15: 13.7, p50: 15.9, p85: 18.4, p97: 21.0 },
  60: { p3: 13.0, p15: 14.4, p50: 16.8, p85: 19.5, p97: 22.4 }
};

// Length/Height-for-age (cm) - Boys, Birth to 5 years
export const WHO_HEIGHT_FOR_AGE_BOYS = {
  0: { p3: 46.3, p15: 47.9, p50: 49.9, p85: 51.8, p97: 53.4 },
  1: { p3: 51.1, p15: 52.7, p50: 54.7, p85: 56.7, p97: 58.4 },
  2: { p3: 54.7, p15: 56.4, p50: 58.4, p85: 60.4, p97: 62.2 },
  3: { p3: 57.6, p15: 59.3, p50: 61.4, p85: 63.5, p97: 65.3 },
  4: { p3: 60.0, p15: 61.7, p50: 63.9, p85: 66.0, p97: 67.8 },
  5: { p3: 61.9, p15: 63.7, p50: 65.9, p85: 68.0, p97: 69.9 },
  6: { p3: 63.6, p15: 65.4, p50: 67.6, p85: 69.8, p97: 71.6 },
  7: { p3: 65.1, p15: 66.9, p50: 69.2, p85: 71.4, p97: 73.2 },
  8: { p3: 66.5, p15: 68.3, p50: 70.6, p85: 72.8, p97: 74.7 },
  9: { p3: 67.7, p15: 69.6, p50: 72.0, p85: 74.2, p97: 76.2 },
  10: { p3: 68.9, p15: 70.8, p50: 73.3, p85: 75.6, p97: 77.6 },
  11: { p3: 70.0, p15: 72.0, p50: 74.5, p85: 76.9, p97: 78.9 },
  12: { p3: 71.0, p15: 73.0, p50: 75.7, p85: 78.1, p97: 80.2 },
  15: { p3: 74.1, p15: 76.2, p50: 79.1, p85: 81.7, p97: 83.9 },
  18: { p3: 76.9, p15: 79.1, p50: 82.3, p85: 85.2, p97: 87.5 },
  21: { p3: 79.4, p15: 81.8, p50: 85.1, p85: 88.2, p97: 90.7 },
  24: { p3: 81.7, p15: 84.2, p50: 87.8, p85: 91.0, p97: 93.6 },
  30: { p3: 85.9, p15: 88.5, p50: 92.3, p85: 95.8, p97: 98.6 },
  36: { p3: 89.6, p15: 92.4, p50: 96.5, p85: 100.2, p97: 103.2 },
  42: { p3: 93.0, p15: 95.9, p50: 100.2, p85: 104.2, p97: 107.4 },
  48: { p3: 96.2, p15: 99.2, p50: 103.7, p85: 108.0, p97: 111.4 },
  54: { p3: 99.1, p15: 102.3, p50: 107.0, p85: 111.5, p97: 115.1 },
  60: { p3: 101.8, p15: 105.2, p50: 110.0, p85: 114.7, p97: 118.5 }
};

// Length/Height-for-age (cm) - Girls, Birth to 5 years
export const WHO_HEIGHT_FOR_AGE_GIRLS = {
  0: { p3: 45.6, p15: 47.2, p50: 49.1, p85: 51.1, p97: 52.7 },
  1: { p3: 50.0, p15: 51.7, p50: 53.7, p85: 55.6, p97: 57.4 },
  2: { p3: 53.2, p15: 55.0, p50: 57.1, p85: 59.1, p97: 61.0 },
  3: { p3: 55.8, p15: 57.7, p50: 59.8, p85: 62.0, p97: 63.9 },
  4: { p3: 58.0, p15: 59.9, p50: 62.1, p85: 64.3, p97: 66.2 },
  5: { p3: 59.9, p15: 61.9, p50: 64.0, p85: 66.2, p97: 68.2 },
  6: { p3: 61.5, p15: 63.5, p50: 65.7, p85: 68.0, p97: 70.0 },
  7: { p3: 62.9, p15: 65.0, p50: 67.3, p85: 69.6, p97: 71.6 },
  8: { p3: 64.3, p15: 66.4, p50: 68.7, p85: 71.1, p97: 73.2 },
  9: { p3: 65.6, p15: 67.7, p50: 70.1, p85: 72.6, p97: 74.7 },
  10: { p3: 66.8, p15: 69.0, p50: 71.5, p85: 74.0, p97: 76.1 },
  11: { p3: 68.0, p15: 70.2, p50: 72.8, p85: 75.3, p97: 77.5 },
  12: { p3: 69.2, p15: 71.4, p50: 74.0, p85: 76.6, p97: 78.9 },
  15: { p3: 72.4, p15: 74.7, p50: 77.5, p85: 80.3, p97: 82.7 },
  18: { p3: 75.3, p15: 77.8, p50: 80.7, p85: 83.7, p97: 86.2 },
  21: { p3: 78.0, p15: 80.6, p50: 83.7, p85: 86.8, p97: 89.5 },
  24: { p3: 80.5, p15: 83.2, p50: 86.4, p85: 89.7, p97: 92.5 },
  30: { p3: 84.8, p15: 87.7, p50: 91.3, p85: 94.8, p97: 97.9 },
  36: { p3: 88.6, p15: 91.7, p50: 95.6, p85: 99.4, p97: 102.7 },
  42: { p3: 92.1, p15: 95.3, p50: 99.5, p85: 103.6, p97: 107.1 },
  48: { p3: 95.4, p15: 98.8, p50: 103.2, p85: 107.6, p97: 111.3 },
  54: { p3: 98.5, p15: 102.0, p50: 106.7, p85: 111.3, p97: 115.2 },
  60: { p3: 101.4, p15: 105.1, p50: 110.0, p85: 114.9, p97: 118.9 }
};

// Head Circumference-for-age (cm) - Boys, Birth to 5 years
export const WHO_HEAD_CIRC_FOR_AGE_BOYS = {
  0: { p3: 32.4, p15: 33.4, p50: 34.5, p85: 35.5, p97: 36.6 },
  1: { p3: 35.2, p15: 36.1, p50: 37.3, p85: 38.4, p97: 39.5 },
  2: { p3: 37.0, p15: 38.0, p50: 39.1, p85: 40.3, p97: 41.3 },
  3: { p3: 38.3, p15: 39.3, p50: 40.5, p85: 41.7, p97: 42.8 },
  4: { p3: 39.4, p15: 40.4, p50: 41.6, p85: 42.9, p97: 43.9 },
  5: { p3: 40.3, p15: 41.3, p50: 42.6, p85: 43.8, p97: 44.9 },
  6: { p3: 41.0, p15: 42.0, p50: 43.3, p85: 44.6, p97: 45.6 },
  7: { p3: 41.7, p15: 42.7, p50: 44.0, p85: 45.2, p97: 46.3 },
  8: { p3: 42.2, p15: 43.2, p50: 44.5, p85: 45.8, p97: 46.9 },
  9: { p3: 42.6, p15: 43.7, p50: 45.0, p85: 46.3, p97: 47.4 },
  10: { p3: 43.0, p15: 44.0, p50: 45.4, p85: 46.7, p97: 47.8 },
  11: { p3: 43.4, p15: 44.4, p50: 45.8, p85: 47.1, p97: 48.2 },
  12: { p3: 43.6, p15: 44.7, p50: 46.1, p85: 47.4, p97: 48.5 },
  15: { p3: 44.2, p15: 45.3, p50: 46.7, p85: 48.1, p97: 49.3 },
  18: { p3: 44.7, p15: 45.8, p50: 47.2, p85: 48.7, p97: 49.9 },
  21: { p3: 45.1, p15: 46.2, p50: 47.7, p85: 49.1, p97: 50.3 },
  24: { p3: 45.5, p15: 46.6, p50: 48.1, p85: 49.5, p97: 50.7 },
  30: { p3: 46.1, p15: 47.2, p50: 48.7, p85: 50.2, p97: 51.4 },
  36: { p3: 46.6, p15: 47.7, p50: 49.3, p85: 50.7, p97: 52.0 },
  42: { p3: 47.0, p15: 48.2, p50: 49.7, p85: 51.2, p97: 52.4 },
  48: { p3: 47.4, p15: 48.5, p50: 50.0, p85: 51.5, p97: 52.7 },
  54: { p3: 47.7, p15: 48.8, p50: 50.4, p85: 51.9, p97: 53.1 },
  60: { p3: 47.9, p15: 49.1, p50: 50.7, p85: 52.2, p97: 53.4 }
};

// Head Circumference-for-age (cm) - Girls, Birth to 5 years
export const WHO_HEAD_CIRC_FOR_AGE_GIRLS = {
  0: { p3: 31.7, p15: 32.7, p50: 33.9, p85: 34.9, p97: 36.0 },
  1: { p3: 34.3, p15: 35.3, p50: 36.5, p85: 37.6, p97: 38.6 },
  2: { p3: 36.0, p15: 37.0, p50: 38.3, p85: 39.4, p97: 40.5 },
  3: { p3: 37.2, p15: 38.2, p50: 39.5, p85: 40.7, p97: 41.8 },
  4: { p3: 38.2, p15: 39.2, p50: 40.5, p85: 41.8, p97: 42.9 },
  5: { p3: 39.0, p15: 40.0, p50: 41.4, p85: 42.7, p97: 43.8 },
  6: { p3: 39.7, p15: 40.8, p50: 42.1, p85: 43.4, p97: 44.5 },
  7: { p3: 40.4, p15: 41.4, p50: 42.8, p85: 44.1, p97: 45.2 },
  8: { p3: 40.9, p15: 42.0, p50: 43.4, p85: 44.7, p97: 45.8 },
  9: { p3: 41.3, p15: 42.4, p50: 43.8, p85: 45.2, p97: 46.3 },
  10: { p3: 41.7, p15: 42.8, p50: 44.2, p85: 45.6, p97: 46.7 },
  11: { p3: 42.0, p15: 43.2, p50: 44.6, p85: 46.0, p97: 47.1 },
  12: { p3: 42.3, p15: 43.5, p50: 44.9, p85: 46.3, p97: 47.5 },
  15: { p3: 43.0, p15: 44.1, p50: 45.6, p85: 47.1, p97: 48.2 },
  18: { p3: 43.5, p15: 44.7, p50: 46.2, p85: 47.7, p97: 48.9 },
  21: { p3: 43.9, p15: 45.1, p50: 46.7, p85: 48.2, p97: 49.4 },
  24: { p3: 44.3, p15: 45.5, p50: 47.1, p85: 48.6, p97: 49.9 },
  30: { p3: 44.9, p15: 46.2, p50: 47.8, p85: 49.4, p97: 50.7 },
  36: { p3: 45.5, p15: 46.7, p50: 48.4, p85: 50.0, p97: 51.4 },
  42: { p3: 45.9, p15: 47.2, p50: 48.8, p85: 50.5, p97: 51.9 },
  48: { p3: 46.3, p15: 47.6, p50: 49.2, p85: 50.9, p97: 52.3 },
  54: { p3: 46.6, p15: 47.9, p50: 49.6, p85: 51.2, p97: 52.6 },
  60: { p3: 46.9, p15: 48.2, p50: 49.9, p85: 51.5, p97: 53.0 }
};

// Weight-for-length/height (kg) - Boys
export const WHO_WEIGHT_FOR_HEIGHT_BOYS = {
  // Length (cm): { p3, p15, p50, p85, p97 }
  45: { p3: 1.9, p15: 2.1, p50: 2.4, p85: 2.7, p97: 3.0 },
  50: { p3: 2.6, p15: 2.9, p50: 3.2, p85: 3.6, p97: 4.0 },
  55: { p3: 3.6, p15: 3.9, p50: 4.3, p85: 4.8, p97: 5.3 },
  60: { p3: 4.7, p15: 5.1, p50: 5.7, p85: 6.3, p97: 6.9 },
  65: { p3: 5.9, p15: 6.4, p50: 7.1, p85: 7.8, p97: 8.5 },
  70: { p3: 7.0, p15: 7.6, p50: 8.4, p85: 9.2, p97: 10.0 },
  75: { p3: 8.0, p15: 8.7, p50: 9.5, p85: 10.4, p97: 11.3 },
  80: { p3: 8.9, p15: 9.6, p50: 10.5, p85: 11.5, p97: 12.5 },
  85: { p3: 9.7, p15: 10.5, p50: 11.5, p85: 12.6, p97: 13.7 },
  90: { p3: 10.5, p15: 11.3, p50: 12.4, p85: 13.6, p97: 14.8 },
  95: { p3: 11.3, p15: 12.2, p50: 13.3, p85: 14.6, p97: 16.0 },
  100: { p3: 12.1, p15: 13.0, p50: 14.3, p85: 15.7, p97: 17.2 },
  105: { p3: 13.0, p15: 14.0, p50: 15.3, p85: 16.9, p97: 18.5 },
  110: { p3: 13.9, p15: 15.0, p50: 16.4, p85: 18.1, p97: 19.9 },
  115: { p3: 14.9, p15: 16.1, p50: 17.6, p85: 19.5, p97: 21.5 },
  120: { p3: 16.0, p15: 17.3, p50: 19.0, p85: 21.1, p97: 23.3 }
};

// Weight-for-length/height (kg) - Girls
export const WHO_WEIGHT_FOR_HEIGHT_GIRLS = {
  45: { p3: 1.9, p15: 2.1, p50: 2.3, p85: 2.6, p97: 2.9 },
  50: { p3: 2.6, p15: 2.8, p50: 3.1, p85: 3.5, p97: 3.9 },
  55: { p3: 3.5, p15: 3.8, p50: 4.2, p85: 4.7, p97: 5.2 },
  60: { p3: 4.5, p15: 4.9, p50: 5.5, p85: 6.1, p97: 6.7 },
  65: { p3: 5.6, p15: 6.1, p50: 6.8, p85: 7.5, p97: 8.3 },
  70: { p3: 6.7, p15: 7.3, p50: 8.0, p85: 8.9, p97: 9.7 },
  75: { p3: 7.6, p15: 8.3, p50: 9.1, p85: 10.1, p97: 11.0 },
  80: { p3: 8.5, p15: 9.2, p50: 10.1, p85: 11.2, p97: 12.2 },
  85: { p3: 9.3, p15: 10.1, p50: 11.1, p85: 12.3, p97: 13.4 },
  90: { p3: 10.1, p15: 11.0, p50: 12.0, p85: 13.3, p97: 14.5 },
  95: { p3: 10.9, p15: 11.8, p50: 13.0, p85: 14.4, p97: 15.8 },
  100: { p3: 11.7, p15: 12.7, p50: 14.0, p85: 15.5, p97: 17.1 },
  105: { p3: 12.6, p15: 13.7, p50: 15.1, p85: 16.8, p97: 18.5 },
  110: { p3: 13.6, p15: 14.8, p50: 16.3, p85: 18.2, p97: 20.1 },
  115: { p3: 14.7, p15: 16.0, p50: 17.7, p85: 19.8, p97: 21.9 },
  120: { p3: 15.9, p15: 17.4, p50: 19.3, p85: 21.6, p97: 24.0 }
};

// Helper function to interpolate between data points
export const interpolatePercentile = (data, value, percentile) => {
  const keys = Object.keys(data).map(Number).sort((a, b) => a - b);
  
  // Find surrounding keys
  let lowerKey = keys[0];
  let upperKey = keys[keys.length - 1];
  
  for (let i = 0; i < keys.length - 1; i++) {
    if (value >= keys[i] && value <= keys[i + 1]) {
      lowerKey = keys[i];
      upperKey = keys[i + 1];
      break;
    }
  }
  
  // If exact match
  if (data[value]) {
    return data[value][percentile];
  }
  
  // Linear interpolation
  const lowerVal = data[lowerKey][percentile];
  const upperVal = data[upperKey][percentile];
  const ratio = (value - lowerKey) / (upperKey - lowerKey);
  
  return lowerVal + (upperVal - lowerVal) * ratio;
};

// Calculate percentile for a given value
export const calculatePercentile = (data, ageOrHeight, value, sex = 'male') => {
  const keys = Object.keys(data).map(Number).sort((a, b) => a - b);
  
  // Get the closest data point
  let closestKey = keys[0];
  let minDiff = Math.abs(ageOrHeight - keys[0]);
  
  for (const key of keys) {
    const diff = Math.abs(ageOrHeight - key);
    if (diff < minDiff) {
      minDiff = diff;
      closestKey = key;
    }
  }
  
  const range = data[closestKey];
  if (!range) return null;
  
  // Determine percentile range
  if (value < range.p3) return { percentile: '<3', status: 'severe', color: '#dc2626' };
  if (value < range.p15) return { percentile: '3-15', status: 'low', color: '#f97316' };
  if (value <= range.p85) return { percentile: '15-85', status: 'normal', color: '#22c55e' };
  if (value <= range.p97) return { percentile: '85-97', status: 'high', color: '#f97316' };
  return { percentile: '>97', status: 'very_high', color: '#dc2626' };
};

// Calculate Z-score (approximate)
export const calculateZScore = (data, ageOrHeight, value) => {
  const keys = Object.keys(data).map(Number).sort((a, b) => a - b);
  
  let closestKey = keys[0];
  let minDiff = Math.abs(ageOrHeight - keys[0]);
  
  for (const key of keys) {
    const diff = Math.abs(ageOrHeight - key);
    if (diff < minDiff) {
      minDiff = diff;
      closestKey = key;
    }
  }
  
  const range = data[closestKey];
  if (!range) return null;
  
  const median = range.p50;
  const sd = (range.p85 - range.p15) / 2; // Approximate SD
  
  return (value - median) / sd;
};

// Determine growth status
export const getGrowthStatus = (weightPercentile, heightPercentile) => {
  const statuses = [];
  
  // Underweight check (Weight-for-age < 3rd percentile)
  if (weightPercentile && weightPercentile.status === 'severe') {
    statuses.push({
      type: 'underweight',
      severity: 'severe',
      label: 'Severely Underweight',
      color: '#dc2626',
      description: 'Weight is below 3rd percentile for age'
    });
  } else if (weightPercentile && weightPercentile.status === 'low') {
    statuses.push({
      type: 'underweight',
      severity: 'moderate',
      label: 'Underweight',
      color: '#f97316',
      description: 'Weight is between 3rd-15th percentile for age'
    });
  }
  
  // Stunting check (Height-for-age < 3rd percentile)
  if (heightPercentile && heightPercentile.status === 'severe') {
    statuses.push({
      type: 'stunting',
      severity: 'severe',
      label: 'Severe Stunting',
      color: '#dc2626',
      description: 'Height is below 3rd percentile for age'
    });
  } else if (heightPercentile && heightPercentile.status === 'low') {
    statuses.push({
      type: 'stunting',
      severity: 'moderate',
      label: 'Stunting',
      color: '#f97316',
      description: 'Height is between 3rd-15th percentile for age'
    });
  }
  
  // Overweight check
  if (weightPercentile && weightPercentile.status === 'very_high') {
    statuses.push({
      type: 'overweight',
      severity: 'severe',
      label: 'Overweight',
      color: '#dc2626',
      description: 'Weight is above 97th percentile for age'
    });
  } else if (weightPercentile && weightPercentile.status === 'high') {
    statuses.push({
      type: 'overweight',
      severity: 'moderate',
      label: 'Risk of Overweight',
      color: '#f97316',
      description: 'Weight is between 85th-97th percentile for age'
    });
  }
  
  // Normal growth
  if (statuses.length === 0) {
    statuses.push({
      type: 'normal',
      severity: 'normal',
      label: 'Normal Growth',
      color: '#22c55e',
      description: 'Growth parameters are within normal range'
    });
  }
  
  return statuses;
};

// Calculate age in months from birth date
export const calculateAgeInMonths = (birthDate, measurementDate = new Date()) => {
  const parseDateString = (dateStr) => {
    if (!dateStr) return null;
    if (typeof dateStr === 'object' && dateStr instanceof Date) return dateStr;
    if (dateStr.includes('/')) {
      const [day, month, year] = dateStr.split('/').map(Number);
      return new Date(year, month - 1, day);
    }
    return new Date(dateStr);
  };

  const birth = parseDateString(birthDate);
  const measurement = parseDateString(measurementDate);

  if (!birth || !measurement) return null;

  const years = measurement.getFullYear() - birth.getFullYear();
  const months = measurement.getMonth() - birth.getMonth();
  const days = measurement.getDate() - birth.getDate();

  let totalMonths = years * 12 + months;
  if (days < 0) totalMonths -= 1;

  return Math.max(0, totalMonths);
};

// Comprehensive growth assessment for a single record
export const assessGrowthRecord = (weight, height, headCircumference, birthDate, sex = 'male', measurementDate = new Date()) => {
  const ageMonths = calculateAgeInMonths(birthDate, measurementDate);
  
  if (ageMonths === null) {
    return { error: 'Could not calculate age' };
  }
  
  const isMale = sex?.toLowerCase() !== 'female';
  
  // Get appropriate WHO data based on sex
  const weightData = isMale ? WHO_WEIGHT_FOR_AGE_BOYS : WHO_WEIGHT_FOR_AGE_GIRLS;
  const heightData = isMale ? WHO_HEIGHT_FOR_AGE_BOYS : WHO_HEIGHT_FOR_AGE_GIRLS;
  const headCircData = isMale ? WHO_HEAD_CIRC_FOR_AGE_BOYS : WHO_HEAD_CIRC_FOR_AGE_GIRLS;
  
  const assessment = {
    ageMonths,
    weight: null,
    height: null,
    headCircumference: null,
    statuses: []
  };
  
  // Weight assessment
  if (weight && !isNaN(parseFloat(weight)) && parseFloat(weight) > 0) {
    const weightVal = parseFloat(weight);
    const weightPercentile = calculatePercentile(weightData, ageMonths, weightVal);
    assessment.weight = {
      value: weightVal,
      percentile: weightPercentile
    };
  }
  
  // Height assessment
  if (height && !isNaN(parseFloat(height)) && parseFloat(height) > 0) {
    const heightVal = parseFloat(height);
    const heightPercentile = calculatePercentile(heightData, ageMonths, heightVal);
    assessment.height = {
      value: heightVal,
      percentile: heightPercentile
    };
  }
  
  // Head circumference assessment (only for 0-5 years)
  if (headCircumference && !isNaN(parseFloat(headCircumference)) && parseFloat(headCircumference) > 0 && ageMonths <= 60) {
    const headCircVal = parseFloat(headCircumference);
    const headCircPercentile = calculatePercentile(headCircData, ageMonths, headCircVal);
    assessment.headCircumference = {
      value: headCircVal,
      percentile: headCircPercentile
    };
  }
  
  // Get overall growth status
  assessment.statuses = getGrowthStatus(
    assessment.weight?.percentile,
    assessment.height?.percentile
  );
  
  return assessment;
};

// Generate chart data for Recharts
export const generateChartData = (whoData, ageRange = [0, 60]) => {
  const chartData = [];
  const [minAge, maxAge] = ageRange;
  
  // Get all available ages in the data
  const ages = Object.keys(whoData)
    .map(Number)
    .filter(age => age >= minAge && age <= maxAge)
    .sort((a, b) => a - b);
  
  for (const age of ages) {
    const data = whoData[age];
    if (data) {
      chartData.push({
        age,
        p3: data.p3,
        p15: data.p15,
        p50: data.p50,
        p85: data.p85,
        p97: data.p97
      });
    }
  }
  
  return chartData;
};

// WHO Reference Data for 5-19 years (in months: 60-228)
// Weight-for-age (kg) - Boys, 5 to 18 years
export const WHO_WEIGHT_FOR_AGE_5_18_BOYS = {
  60: { p3: 14.1, p15: 15.4, p50: 17.5, p85: 19.8, p97: 22.0 },
  72: { p3: 16.0, p15: 17.5, p50: 20.0, p85: 23.0, p97: 26.0 },
  84: { p3: 18.0, p15: 19.8, p50: 22.8, p85: 26.5, p97: 30.5 },
  96: { p3: 20.0, p15: 22.2, p50: 25.8, p85: 30.5, p97: 35.5 },
  108: { p3: 22.5, p15: 25.0, p50: 29.2, p85: 35.0, p97: 41.5 },
  120: { p3: 25.0, p15: 28.0, p50: 33.0, p85: 40.0, p97: 48.5 },
  132: { p3: 28.0, p15: 31.5, p50: 37.5, p85: 46.0, p97: 56.0 },
  144: { p3: 31.5, p15: 35.5, p50: 42.5, p85: 53.0, p97: 64.5 },
  156: { p3: 35.5, p15: 40.0, p50: 48.5, p85: 60.5, p97: 73.5 },
  168: { p3: 40.0, p15: 45.0, p50: 54.5, p85: 67.5, p97: 81.5 },
  180: { p3: 44.5, p15: 50.0, p50: 60.0, p85: 73.5, p97: 88.0 },
  192: { p3: 48.5, p15: 54.5, p50: 64.5, p85: 78.5, p97: 93.0 },
  204: { p3: 51.5, p15: 57.5, p50: 67.5, p85: 82.0, p97: 96.5 },
  216: { p3: 53.5, p15: 59.5, p50: 69.5, p85: 84.0, p97: 98.5 }
};

// Weight-for-age (kg) - Girls, 5 to 18 years
export const WHO_WEIGHT_FOR_AGE_5_18_GIRLS = {
  60: { p3: 13.0, p15: 14.4, p50: 16.8, p85: 19.5, p97: 22.4 },
  72: { p3: 15.0, p15: 16.5, p50: 19.5, p85: 23.0, p97: 27.0 },
  84: { p3: 17.0, p15: 19.0, p50: 22.5, p85: 27.0, p97: 32.0 },
  96: { p3: 19.5, p15: 21.8, p50: 26.0, p85: 31.5, p97: 38.0 },
  108: { p3: 22.0, p15: 24.8, p50: 30.0, p85: 37.0, p97: 45.0 },
  120: { p3: 25.0, p15: 28.5, p50: 34.5, p85: 43.5, p97: 53.5 },
  132: { p3: 28.5, p15: 32.5, p50: 40.0, p85: 50.5, p97: 62.5 },
  144: { p3: 32.5, p15: 37.0, p50: 45.5, p85: 57.5, p97: 71.0 },
  156: { p3: 36.5, p15: 41.5, p50: 50.5, p85: 63.5, p97: 78.0 },
  168: { p3: 40.0, p15: 45.0, p50: 54.5, p85: 68.0, p97: 83.0 },
  180: { p3: 42.5, p15: 47.5, p50: 57.0, p85: 71.0, p97: 86.5 },
  192: { p3: 44.0, p15: 49.0, p50: 58.5, p85: 72.5, p97: 88.0 },
  204: { p3: 44.5, p15: 49.5, p50: 59.0, p85: 73.0, p97: 88.5 },
  216: { p3: 45.0, p15: 50.0, p50: 59.5, p85: 73.5, p97: 89.0 }
};

// Height-for-age (cm) - Boys, 5 to 18 years
export const WHO_HEIGHT_FOR_AGE_5_18_BOYS = {
  60: { p3: 101.8, p15: 105.2, p50: 110.0, p85: 114.7, p97: 118.5 },
  72: { p3: 108.0, p15: 111.5, p50: 116.5, p85: 121.5, p97: 125.5 },
  84: { p3: 113.5, p15: 117.5, p50: 122.5, p85: 128.0, p97: 132.0 },
  96: { p3: 118.5, p15: 122.8, p50: 128.2, p85: 134.0, p97: 138.5 },
  108: { p3: 123.5, p15: 128.0, p50: 133.8, p85: 139.8, p97: 144.5 },
  120: { p3: 128.0, p15: 132.8, p50: 139.0, p85: 145.5, p97: 150.5 },
  132: { p3: 132.5, p15: 137.5, p50: 144.0, p85: 151.0, p97: 156.5 },
  144: { p3: 137.0, p15: 142.5, p50: 149.5, p85: 157.0, p97: 163.0 },
  156: { p3: 142.0, p15: 148.0, p50: 155.5, p85: 163.5, p97: 170.0 },
  168: { p3: 148.0, p15: 154.5, p50: 162.5, p85: 170.5, p97: 177.0 },
  180: { p3: 154.0, p15: 160.5, p50: 168.5, p85: 176.0, p97: 182.0 },
  192: { p3: 158.5, p15: 164.5, p50: 172.0, p85: 179.5, p97: 185.0 },
  204: { p3: 161.5, p15: 167.0, p50: 174.0, p85: 181.0, p97: 186.5 },
  216: { p3: 163.0, p15: 168.5, p50: 175.0, p85: 182.0, p97: 187.5 }
};

// Height-for-age (cm) - Girls, 5 to 18 years
export const WHO_HEIGHT_FOR_AGE_5_18_GIRLS = {
  60: { p3: 101.4, p15: 105.1, p50: 110.0, p85: 114.9, p97: 118.9 },
  72: { p3: 107.5, p15: 111.5, p50: 116.5, p85: 121.5, p97: 125.5 },
  84: { p3: 113.0, p15: 117.0, p50: 122.5, p85: 128.0, p97: 132.5 },
  96: { p3: 118.0, p15: 122.5, p50: 128.2, p85: 134.0, p97: 139.0 },
  108: { p3: 123.0, p15: 127.8, p50: 134.0, p85: 140.5, p97: 146.0 },
  120: { p3: 128.0, p15: 133.0, p50: 139.8, p85: 147.0, p97: 152.5 },
  132: { p3: 133.0, p15: 138.5, p50: 146.0, p85: 153.5, p97: 159.5 },
  144: { p3: 138.5, p15: 144.5, p50: 152.5, p85: 160.5, p97: 166.5 },
  156: { p3: 143.5, p15: 149.5, p50: 157.5, p85: 165.0, p97: 170.5 },
  168: { p3: 147.0, p15: 152.5, p50: 160.0, p85: 167.0, p97: 172.5 },
  180: { p3: 148.5, p15: 153.8, p50: 161.0, p85: 168.0, p97: 173.5 },
  192: { p3: 149.0, p15: 154.2, p50: 161.5, p85: 168.5, p97: 174.0 },
  204: { p3: 149.2, p15: 154.5, p50: 161.8, p85: 168.8, p97: 174.2 },
  216: { p3: 149.5, p15: 154.8, p50: 162.0, p85: 169.0, p97: 174.5 }
};

// BMI-for-age - Boys, 5 to 18 years (in months: 60-216)
export const WHO_BMI_FOR_AGE_BOYS = {
  60: { p3: 13.0, p15: 13.8, p50: 15.2, p85: 16.9, p97: 18.5 },
  72: { p3: 13.0, p15: 13.8, p50: 15.3, p85: 17.2, p97: 19.2 },
  84: { p3: 13.1, p15: 13.9, p50: 15.5, p85: 17.6, p97: 20.0 },
  96: { p3: 13.2, p15: 14.1, p50: 15.8, p85: 18.2, p97: 21.0 },
  108: { p3: 13.4, p15: 14.4, p50: 16.2, p85: 18.9, p97: 22.2 },
  120: { p3: 13.7, p15: 14.7, p50: 16.7, p85: 19.7, p97: 23.5 },
  132: { p3: 14.0, p15: 15.1, p50: 17.3, p85: 20.6, p97: 24.8 },
  144: { p3: 14.4, p15: 15.6, p50: 17.9, p85: 21.5, p97: 26.0 },
  156: { p3: 14.9, p15: 16.1, p50: 18.6, p85: 22.4, p97: 27.2 },
  168: { p3: 15.4, p15: 16.7, p50: 19.3, p85: 23.2, p97: 28.2 },
  180: { p3: 15.9, p15: 17.2, p50: 20.0, p85: 23.9, p97: 29.0 },
  192: { p3: 16.4, p15: 17.8, p50: 20.6, p85: 24.5, p97: 29.6 },
  204: { p3: 16.8, p15: 18.2, p50: 21.1, p85: 25.0, p97: 30.0 },
  216: { p3: 17.2, p15: 18.6, p50: 21.5, p85: 25.4, p97: 30.3 }
};

// BMI-for-age - Girls, 5 to 18 years (in months: 60-216)
export const WHO_BMI_FOR_AGE_GIRLS = {
  60: { p3: 12.7, p15: 13.5, p50: 15.0, p85: 17.0, p97: 19.0 },
  72: { p3: 12.7, p15: 13.5, p50: 15.1, p85: 17.3, p97: 19.7 },
  84: { p3: 12.8, p15: 13.6, p50: 15.4, p85: 17.8, p97: 20.5 },
  96: { p3: 12.9, p15: 13.8, p50: 15.7, p85: 18.4, p97: 21.5 },
  108: { p3: 13.1, p15: 14.1, p50: 16.2, p85: 19.2, p97: 22.7 },
  120: { p3: 13.5, p15: 14.5, p50: 16.8, p85: 20.1, p97: 24.0 },
  132: { p3: 13.9, p15: 15.0, p50: 17.5, p85: 21.1, p97: 25.4 },
  144: { p3: 14.4, p15: 15.6, p50: 18.3, p85: 22.1, p97: 26.6 },
  156: { p3: 15.0, p15: 16.2, p50: 19.1, p85: 23.0, p97: 27.6 },
  168: { p3: 15.5, p15: 16.8, p50: 19.8, p85: 23.8, p97: 28.4 },
  180: { p3: 16.0, p15: 17.3, p50: 20.4, p85: 24.4, p97: 29.0 },
  192: { p3: 16.4, p15: 17.7, p50: 20.8, p85: 24.8, p97: 29.4 },
  204: { p3: 16.6, p15: 18.0, p50: 21.1, p85: 25.1, p97: 29.6 },
  216: { p3: 16.8, p15: 18.2, p50: 21.3, p85: 25.3, p97: 29.8 }
};

// Generate combined chart data for 0-18 years
export const generateChartData0to18 = (whoData0to5, whoData5to18, ageRange = [0, 216]) => {
  const chartData = [];
  const [minAge, maxAge] = ageRange;
  
  // Combine both datasets
  const combined = { ...whoData0to5, ...whoData5to18 };
  
  const ages = Object.keys(combined)
    .map(Number)
    .filter(age => age >= minAge && age <= maxAge)
    .sort((a, b) => a - b);
  
  for (const age of ages) {
    const data = combined[age];
    if (data) {
      chartData.push({
        age,
        p3: data.p3,
        p15: data.p15,
        p50: data.p50,
        p85: data.p85,
        p97: data.p97
      });
    }
  }
  
  return chartData;
};

// Generate weight-for-height chart data
export const generateWeightForHeightData = (whoData, heightRange = [45, 120]) => {
  const chartData = [];
  const [minHeight, maxHeight] = heightRange;
  
  const heights = Object.keys(whoData)
    .map(Number)
    .filter(h => h >= minHeight && h <= maxHeight)
    .sort((a, b) => a - b);
  
  for (const height of heights) {
    const data = whoData[height];
    if (data) {
      chartData.push({
        height,
        p3: data.p3,
        p15: data.p15,
        p50: data.p50,
        p85: data.p85,
        p97: data.p97
      });
    }
  }
  
  return chartData;
};
